"use strict";
angular.module('mean.trades').controller('TradeTasksController', ['$scope', '$timeout', 'Global', 'generalTaskConstant', 'commonConstant', 'csvExport', 'MeanUser', 'GeneralTasks', '$filter', 'tradeCodeService', 'Subtasks', 'userService',
    'Trades', 'Materials', 'Units', 'Equipments', 'toaster', 'ngDialog', 'Users', 'CombinationService',
    function ($scope, $timeout, Global, generalTaskConstant, commonConstant, csvExport, MeanUser, GeneralTasks, $filter, tradeCodeService, Subtasks, userService, Trades, Materials, Units, Equipments, toaster, ngDialog, Users, CombinationService) {

        $scope.global = Global;
        $scope.tasks = [];
        $scope.all_tasks = [];
        $scope.editId = -1;
        $scope.editSubtask = null;
        $scope.suppliersList = [];
        $scope.equipmentSuppliersList = [];
        $scope.selector = {};
        $scope.units = [];
        $scope.equipment = [];
        $scope.sortType = ['name'];
        $scope.sortReverse = false;
        $scope.matSortType = ['name'];
        $scope.matSortReverse = false;
        $scope.commonConstant = commonConstant
        $scope.menu_items = generalTaskConstant.menus;
        $scope.material_menu = generalTaskConstant.material_menu;
        $scope.selectedCombination = '';
        $scope.user = MeanUser.user;
        $scope.adminUser = null;
        $scope.isCustomSelected = false;
        $scope.isInventory = false;
        $scope.selectedCatergory = '';
        $scope.selectedSupplier = '';
        $scope.customComb = {};
        $scope.customTasks = [];
        $scope.cus_subtask = {};
        $scope.cus_gentask = {};
        $scope.selectedOpt = {};
        $scope.main_account_id = null;
        $scope.customGeneraltask = [];
        $scope.main_account_client ='';
        $scope.defaultMaterialType = 'All';

        $scope.hasAuthorization = function (task) {
            if (!task || !task.user) return false;
            return $scope.global.isAdmin || task.user._id === $scope.global.user._id;
        };

        Units.query({}, function (units) {
            $scope.units = units
        });


        $scope.updateOptin = function (option) {
            if (option) {
                $scope.selectedOpt = {
                    'projectType': option['projectType'] || option['type'],
                    'geoLocation': option['geoLocation'] || option['location'],
                    'isCustom': option['isCustom'] || false,
                    'userId': option['userId'] || ''
                }
            }
        }

        $scope.init = function () {

            //merge general tasks with system subtasks
            userService.getMainAccount($scope.user.username).then(function (user) {
                $scope.user.combination = user.combination;
                $scope.main_account_id = user._id;
                $scope.main_account_client = user.username.slice(0,5);
                // get admin users
                Users.query({ username: $scope.user.username }, function (result) {
                    if (result.length) {
                        $scope.adminUser = result[0];
                        // remove other user combination
                        $scope.adminUser.combination = $scope.adminUser.combination.filter(item => {
                            return (item.userId == $scope.main_account_id) || (!item.hasOwnProperty('userId') || item.userId == '');
                        });
                    }
                });

                Trades.query({ 'main_account_id': user._id }, function (trade) {
                    $scope.my_trade = trade[0];
                    $scope.my_subs = trade[0].subtasks;
                    $scope.my_trade_code = tradeCodeService.getCode($scope.user.trade[0]);
                    Equipments.query({ 'trade_account': $scope.my_trade._id }, function (eq) {
                        $scope.equipment = eq;
                    });
                    Materials.query({ 'trade_account': $scope.my_trade._id, 'get_suppliers': true, 'userId': $scope.main_account_id },
                        function (materials) {
                            $scope.suppliersList = materials;
                        });

                    Equipments.query({ 'trade_account': $scope.my_trade._id, 'get_suppliers': true },
                        function (eq) {
                            $scope.equipmentSuppliersList = eq;
                        });
                    $scope.getCustomTasks();

                    $scope.getTradeAccount();
                });
            });

            $scope.onMenuSelect(0);
        };

        $scope.getCustomTasks = () => {
            GeneralTasks.query({ 'username': $scope.user.username }, function (results) {
                $scope.customGeneraltask = $scope.customTasks = $filter('orderBy')(results, 'order');
            });
        }

        $scope.addCustomSubTask = (indexNo) => {
            ngDialog.openConfirm({
                template: 'trades/views/tmpl/trade-add-custom-subtask.html',
                scope: $scope,
                className: 'ngdialog-theme-default ngdialg-padding ngdialog-sm ',
                closeByDocument: false,
                closeByEscape: false,
            }).then((value) => {
                $scope.addSubTask(value, (indexNo + 1));
            }, (value) => {
                $scope.cus_subtask = {};
            });
        }

        $scope.addSubTask = (value, indexNo) => {
            var taskCode = indexNo < 10 ? ('0' + indexNo) : indexNo.toString();
            var checkDuplicate = $filter('filter')($scope.my_trade.subtasks, {
                'task': taskCode,
                'name': value.subtask_name,
                'projectType': $scope.selectedOpt['projectType'],
                'geoLocation': $scope.selectedOpt['geoLocation'],
                'isCustom': true,
                'userId': $scope.main_account_id
            }, true);
            if (!checkDuplicate.length) {
                var newSubtask = new Subtasks({
                    subtask_code: $scope.my_trade_code + taskCode,
                    subtask_trade: $scope.my_trade_code,
                    subtask: taskCode,
                    subtask_name: value.subtask_name,
                    unit: value.unit._id,
                    piece_rate: 0,
                    crew_rate: 0,
                    piece_per_hour_rate: 0,
                    materials: [],
                    projectType: $scope.selectedOpt['projectType'],
                    geoLocation: $scope.selectedOpt['geoLocation'],
                    isCustom: $scope.selectedOpt['isCustom'],
                    userId: $scope.selectedOpt['userId']
                });
                newSubtask.$save(function (result) {
                    $scope.updateTradeSubtasks(result);
                })
            } else {
                $scope.cus_subtask = {};
                toaster.pop('error', 'Duplicate',
                    'Duplicate subtasks.');
            }
        }
        /**
         * @description add new subtask to trade
         */
        $scope.updateTradeSubtasks = (result) => {
            var findUnit = $scope.units.filter(item => item._id === result.unit)
            var newTradeSubtask = {
                'subtask_id': result._id,
                'name': result.subtask_name,
                'code': result.subtask_code,
                'task': result.subtask,
                'trade': result.subtask_trade,
                'unit': findUnit[0] ? findUnit[0].unit : 'NA',
                'crew_rate': result.crew_rate,
                'materials': result.materials,
                'piece_rate': result.piece_rate,
                'piece_per_hour_rate': result.piece_per_hour_rate,
                'geoLocation': result.geoLocation,
                'projectType': result.projectType,
                'isCustom': $scope.selectedOpt['isCustom'],
                'userId': $scope.selectedOpt['userId']
            }

            $scope.my_trade.subtasks.push(newTradeSubtask);
            $scope.my_trade.$update(function (trade) {
                var qery = {
                    'trade': $scope.my_trade_code,
                    'projectType': $scope.selectedOpt['projectType'],
                    'geoLocation': $scope.selectedOpt['geoLocation'],
                    'isCustom': $scope.selectedOpt['isCustom'],
                    'userId': $scope.selectedOpt['userId']
                }
                $scope.cus_subtask = {};
                $scope.updateCustomTasks(qery);
            })
        }
        /**
         * @description show popup for custom general task
         */
        $scope.addCustomGenTask = () => {
            ngDialog.openConfirm({
                template: 'trades/views/tmpl/trade-add-custom-general-task.html',
                scope: $scope,
                className: 'ngdialog-theme-default ngdialg-padding ngdialog-sm ',
                closeByDocument: false,
                closeByEscape: false,
            }).then((value) => {
                if (value['task_name']) {
                    $scope.addGeneralTasks(value);
                }
            }, (value) => {
                $scope.cus_gentask = {};
            });
        }

        /**
         * @description function for add new custom genereal task
         */
        $scope.addGeneralTasks = (value) => {
            // check duplicate duplicate general task name
            GeneralTasks.query({
                'trade': $scope.my_trade_code,
                'projectType': $scope.selectedOpt['projectType'],
                'geoLocation': $scope.selectedOpt['geoLocation'],
                'isCustom': $scope.selectedOpt['isCustom'],
                'userId': $scope.selectedOpt['userId']
            }, function (results) {
                var ordered_tasks = $filter('orderBy')($scope.customGeneraltask, 'order');
                var newCode = results.length ? (results.length + 1) : 1;
                var chekDuplicate = $filter('filter')(ordered_tasks, { 'task_name': value.task_name }, true);
                if (!chekDuplicate.length) {
                    var taskCode = newCode < 10 ? ('0' + newCode) : newCode;
                    if(ordered_tasks.length) {
                        var newTaskCode = ordered_tasks[ordered_tasks.length -1].task_code;
                        var task_code = newTaskCode.substr(2,2);
                        newCode = (Number(task_code) + 1);
                        taskCode = newCode < 10 ? ('0' + newCode.toString()) : newCode.toString();
                    }

                    var newGenTask = new GeneralTasks({
                        order: Number(newCode),
                        trade: $scope.my_trade_code,
                        task_code: $scope.my_trade_code + taskCode,
                        task: taskCode.toString(),
                        task_name: value.task_name,
                        projectType: $scope.selectedOpt['projectType'],
                        geoLocation: $scope.selectedOpt['geoLocation'],
                        isCustom: $scope.selectedOpt['isCustom'],
                        userId: $scope.selectedOpt['userId'],
                        location: 'Both'
                    });
                    newGenTask.$save(function (result) {
                        var qery = {
                            'trade': $scope.my_trade_code,
                            'projectType': $scope.selectedOpt['projectType'],
                            'geoLocation': $scope.selectedOpt['geoLocation'],
                            'isCustom': true,
                            'userId': $scope.selectedOpt['userId']
                        }
                        $scope.cus_gentask = {};
                        $scope.updateCustomTasks(qery);
                    });
                } else {
                    $scope.cus_gentask = {};
                    toaster.pop('error', 'Duplicate',
                        'Duplicate general task name.');
                }
            });
        }

        /**
         * @description function for update general task to the view
         */
        $scope.updateCustomTasks = (query) => {
            GeneralTasks.query(query, function (results) {

                $scope.customGeneraltask = $scope.customTasks = $filter('orderBy')(results, 'order');
                for (var i = 0; i < $scope.customTasks.length; i++) {

                    var subs = $filter('filter')($scope.my_trade.subtasks, {
                        'task': $scope.customTasks[i].task,
                        'projectType': query['projectType'],
                        'geoLocation': query['geoLocation']
                    }, true);

                    $scope.customTasks[i].subtasks = $filter('orderBy')(subs, 'name');
                }
            });
        }

        /**
         * @description popup for new custom combination
         */
        $scope.addCustomTask = () => {
            ngDialog.openConfirm({
                template: 'trades/views/tmpl/trade-add-custom-task.html',
                scope: $scope,
                className: 'ngdialog-theme-default ngdialg-padding ngdialog-sm ',
                closeByDocument: false,
                closeByEscape: false,
            }).then((value) => {
                var addedCustom = {
                    'projectType': value['projectType'],
                    'geoLocation': value['geoLocation']
                }
                $scope.addUserCombination(addedCustom);
            }, (value) => {
                $scope.customComb = {};
            });
        }

        /**
         * @description add user combination
         */
        $scope.addUserCombination = (value) => {
            var _self = this;
            CombinationService.query({}, function (results) {
                if (results.length) {
                    var combObj = {
                        'projectType': value['projectType'],
                        'geoLocation': value['geoLocation'],
                        'isCustom': true,
                        'userId': $scope.main_account_id
                    };
                    var found = $filter('filter')(results, combObj, true);
                    if (Array.isArray(found) && !found.length) {
                        var combination = new CombinationService(combObj);
                        combination.$save((result) => {
                            if (result) {
                                _self.customComb = {};
                                $scope.addCombiantionToUser(result);
                            }
                        });
                    } else {
                        toaster.pop('error', 'Duplicate Combination',
                            'This project combination is already added.');
                    }
                }
            });
        }

        /**
         * @description add combination to the user
         */
        $scope.addCombiantionToUser = (value) => {
            $scope.adminUser.combination.push({
                'id': value._id,
                'label': value.projectType + ' (' + value.geoLocation + ')',
                'projectType': value.projectType,
                'type': value.projectType,
                'geoLocation': value.geoLocation,
                'location': value.geoLocation,
                'isCustom': true,
                'userId': $scope.main_account_id
            });
            $scope.adminUser.$update(function(res) {
                 Users.query({'client':$scope.main_account_client, 'type':'updateClientUser'},function(users){
                    users.forEach(e =>{
                        e.combination = $scope.adminUser.combination;
                        e.$update();
                    })
                 });
            });
        }

        /**
         * @description getting the general task
         */
        $scope.getGnrlTask = (query) => {
            $scope.isCustomSelected = false;
            GeneralTasks.query(query, function (tasks) {
                $scope.all_tasks = $scope.tasks = $filter('orderBy')(tasks, 'order');

                for (var i = 0; i < $scope.all_tasks.length; i++) {

                    var subs = $filter('filter')($scope.my_trade.subtasks,
                        {
                            'task': $scope.all_tasks[i].task,
                            'projectType': query['projectType'],
                            'geoLocation': query['geoLocation']
                        }, true);

                    $scope.all_tasks[i].subtasks = $filter('orderBy')(subs, 'name');
                }
            });
        };
        $scope.getFilterData = function () {
            Materials.query({
                'type': 'MaterialFilter',
                'supplier': 1,
                'trade_account': $scope.my_trade._id,
                //'isInventory': $scope.isInventory,
                'userId': $scope.main_account_id
            }, function (supliers) {
                $scope.supplierOptions = supliers;
                $scope.supplierOptions.unshift('All');
            });
            $scope.onSupplierChange('All');
        };

        /**
         * @description getting the category list on selection of supplier
         */
        $scope.onSupplierChange = (selectedSupplier) =>{
            var query ={
                'type': 'MaterialFilter',
                'category': 1,
                'trade_account': $scope.my_trade._id,
                //'isInventory': $scope.isInventory,
                'userId': $scope.main_account_id
            };
            selectedSupplier !== 'All' && (query['selectedSupplier'] = selectedSupplier);
            Materials.query(query, function (categories) {
                $scope.categoryOptions = categories;
                $scope.categoryOptions.unshift('All');
            });
        };

        $scope.clearFilter = function () {
            $timeout(function () {
                $scope.materials = [];
            }, 100)
        };
        $scope.onSelect = function () {
            if ($scope.selectedItem) {
                $scope.tasks = $filter('filter')($scope.tasks, { trade: $scope.selectedItem });
            } else {
                $scope.tasks = $scope.all_tasks;
            }
        };

        $scope.setEditId = function (item) {
            if($scope.editId != -1) {
                //pass in the old subtask to update
                $scope.updateTradeSubtasks(item);
            }
            $scope.editSubtask = item;
            $scope.editId = item._id;
        };

        $scope.resetEditId = function () {
            $scope.editSubtask = null;
            $scope.editId = -1;
        };

        $scope.setDeleteSubtask = function (item) {
            var idx = $scope.subtasks.indexOf(item);
            $scope.subtasks.splice(idx, 1);

            item.$delete();
        };

        $scope.setDeleteId = function (mat) {
            var idx = $scope.materials.indexOf(mat);
            $scope.materials.splice(idx, 1);

            mat.$delete();
        };

        $scope.deleteOperation = function (material) {
            ngDialog.openConfirm({
                template:
                    '<h2>Delete Confirm</h2>' +
                    '<p>This operation will remove the material from the database.</p>' +
                    '<p><br><t><strong>Do you wish to continue?</strong></p>' +
                    '<div>' +
                    '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                    '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                    '</button></div>',
                plain: true,
                className: 'ngdialog-theme-default'
            }).then(function (value) {
                // perform delete operation
                $scope.setDeleteId(material);
            }, function (value) {
                //Do something
                console.log('in the do something section');
            });
        };

        $scope.setDeleteEquipment = function (item) {
            var idx = $scope.equipment.indexOf(item);
            $scope.equipment.splice(idx, 1);

            item.$delete();
        };

        $scope.closeEdit = function (item) {
            $scope.update(item);
            $scope.editSubtask = null;
            $scope.editId = -1;
        };

        $scope.closeMatEdit = function (item) {
            $scope.updateMaterial(item);
            $scope.editSubtask = null;
            $scope.editId = -1;
        };

        $scope.updateSubtask = function (item) {
            $scope.update(item);
        };

        $scope.update = function (item) {
            if (!item.piece_per_hour_rate) item.piece_per_hour_rate = 0;
            if (!item.piece_rate) item.piece_rate = 0;

            if (item.piece_rate > 0 && item.piece_per_hour_rate > 0) {
                toaster.pop('error', 'Rate Error',
                    'Piece per Quantity or Piece per Hour has to be zero');
                return;
            }

            if (!item.unit) {
                var found = $filter('filter')($scope.units, { 'unit': 'NA' }, true);
                item.unit = found[0];
            } else if (!item.unit.unit) {
                var found = $filter('filter')($scope.units, { 'unit': item.unit }, true);
                item.unit = found[0];
            }

            //first see if we have this item in our list
            var in_list = $filter('filter')($scope.my_trade.subtasks, { 'subtask_id': item.subtask_id }, true);

            if (in_list.length === 0) {
                // we need to add here
                $scope.my_trade.subtasks.push({
                    'subtask_id': item._id,
                    'name': item.subtask_name,
                    'code': item.subtask_code,
                    'task': item.subtask,
                    'trade': item.subtask_trade,
                    'unit': item.unit.unit,
                    'category': item.category,
                    'crew_rate': item.crew_rate,
                    'piece_rate': item.piece_rate,
                    'projectType': item.projectType,
                    'geoLocation': item.geoLocation,
                    'piece_per_hour_rate': item.piece_per_hour_rate
                });
            } else if (in_list.length === 1) {
                //we need to update here
                in_list[0].name = item.name;
                in_list[0].unit = item.unit.unit;
                in_list[0].category = item.category;
                in_list[0].crew_rate = Number(item.crew_rate);
                in_list[0].piece_rate = Number(item.piece_rate);
                in_list[0].piece_per_hour_rate = Number(item.piece_per_hour_rate);
            } else {
                toaster.pop('error', 'Trade Database', 'Problem with getting the subtask from the list');
                return;
            }

            $scope.my_trade.$update(function (results) {
                $scope.my_trade = results;
                if (item.unit.unit) item.unit = item.unit.unit;
                var qery = {
                    'trade': $scope.my_trade_code,
                    'projectType': $scope.selectedOpt['projectType'],
                    'geoLocation': $scope.selectedOpt['geoLocation'],
                    'isCustom': true,
                    'userId': $scope.selectedOpt['userId']
                }
                $scope.cus_gentask = {};
                $scope.updateCustomTasks(qery);
                toaster.pop('success', 'Trade Database', 'Trade Database has been updated');
            }, function (error) {
                toaster.pop('error', 'Trade Database', error);
            });
        };

        $scope.deleteSubTask = function (item) {

            var subtasks = angular.copy($scope.my_trade.subtasks);
            var indexNo = subtasks.findIndex(function(subItem) {
                return subItem.subtask_id == item.subtask_id;
            });
            if (indexNo !== -1) {
                subtasks.splice(indexNo, 1);
                $scope.my_trade.subtasks = subtasks;
                $scope.my_trade.$update(function (results) {
                    $scope.my_trade = results;
                    $scope.getGnrlTskCombination($scope.selectedOpt);
                    toaster.pop('success', 'Trade Database', 'Trade Database has been updated');
                }, function (error) {
                    toaster.pop('error', 'Trade Database', error);
                });
            }
        };

        $scope.getTradeName = function (id) {
            return tradeCodeService.getName(id);
        };

        $scope.onMenuSelect = function (index) {
            $scope.current_menu_selection = $scope.menu_items[index];
            $scope.menu_items[index] === 'Materials' && $scope.onMaterialSelect(0);
        };

        $scope.onMaterialSelect = function (index) {

            $scope.materials = [];
            $scope.current_material_selection = $scope.material_menu[index];
            $scope.isInventory = $scope.current_material_selection !== $scope.material_menu[0];
            $scope.getFilterData();

        };

        $scope.updateMaterial = function (mat) {
            if (!mat.trade_account)
                mat.trade_account = $scope.my_trade._id;

            if(!mat.userId)
                mat.userId = $scope.main_account_id;

            mat.$update();
        };

        $scope.updateEquipment = function (eq) {
            if (!eq.trade_account)
                eq.trade_account = $scope.my_trade._id;

            eq.$update();
        };

        $scope.changeSupplier = function () {
            if (angular.isUndefined(this.selectedSupplier))
                this.selectedSupplier = "";

            if (this.selectedSupplier === null)
                this.selectedSupplier = "";
        };

        $scope.fileSelected = function () {
            var lines, lineNumber, data, length;
console.log('in fileSelected');
            lines = this.$parent.fileContent.split('\n');
            lineNumber = 0;
            var holder = [];
            for (var i = lines.length - 1; i > 0; i--) {
                var l = lines[i];

                lineNumber++;
                data = l.split(',');

                if (!data[0]) continue;

                var name = data[0];
                var category = data[1];
                var supplier = data[2];
                var price_per_order = data[3] ? Number(data[3].replace(/[^0-9\.]+/g, "")) : 0;
                var delivery_price = data[4] ? Number(data[4].replace(/[^0-9\.]+/g, "")) : 0;
                var piece_per_size = data[5] ? Number(data[5].replace(/[^0-9\.]+/g, "")) : 0;
                var unit = $filter('filter')($scope.units, { 'unit': data[6] }, true);
                if (!unit[0]) {
                    var found = $filter('filter')($scope.units, { 'unit': 'NA' }, true);
                    if (found[0]) unit = found;
                    else continue;
                }
                var delivery_offset = Number(data[7]) * 1;

                var dataObject = {
                    name: name,
                    trade: $scope.my_trade_code,
                    trade_account: $scope.my_trade._id,
                    supplier: supplier,
                    category: category,
                    price_per_order: price_per_order,
                    delivery_price: delivery_price,
                    piece_per_size: piece_per_size,
                    unit: {
                        _id: (unit[0]) ? unit[0]._id : '',
                        unit: (unit[0]) ? unit[0].unit : ''
                    },
                    delivery_offset: delivery_offset,
                    userId: $scope.main_account_id
                }

                if (data[10] == 'Yes') {
                    dataObject['isInventory'] = true;
                    dataObject['bulkQuantity'] = data[8] ? Number(data[8].replace(/[^0-9\.]+/g, "")) : 0;
                    dataObject['bulkPrice'] = data[9] ? Number(data[9].replace(/[^0-9\.]+/g, "")) : 0;
                } else {
                    dataObject['isInventory'] = false;
                    dataObject['bulkQuantity'] = 0;
                    dataObject['bulkPrice'] = 0;
                }

                var mat = new Materials(dataObject);
                holder.push(mat);
            }

            if (!holder.length) {
                toaster.pop('error', 'Import File',
                    'No Data to import. Please check your import file.');
                delete this.$parent.fileContent;
                return;
            }

            Materials.bulkAdd(holder, function (results) {
                results.forEach(function (mat) {
                    if ($scope.suppliersList.indexOf(mat.supplier) === -1)
                        $scope.suppliersList.push(mat.supplier)
                    // add new category and suplier to the list
                    !$scope.categoryOptions.includes(mat.category) && $scope.categoryOptions.push(mat.category);
                    !$scope.supplierOptions.includes(mat.supplier) && $scope.supplierOptions.push(mat.supplier);
                });
                $timeout(function () {
                    $scope.selectedCatergory = '';
                    $scope.selectedSupplier = '';
                    $scope.materials = results;
                }, 0)
                angular.element("input[type='file']").val(null);
            });

            delete this.$parent.fileContent;
        };

        $scope.equipmentFileSelected = function () {
            var lines, lineNumber, data, length;

            lines = this.$parent.fileContent.split('\n');
            lineNumber = 0;
            var holder = [];
            for (var i = lines.length - 1; i > 0; i--) {
                var l = lines[i];

                lineNumber++;
                data = l.split(',');

                if (!data[0]) continue;

                var name = data[0];
                var category = data[1];
                var supplier = data[2];
                var price_per_order = Number(data[3].replace(/[^0-9\.]+/g, ""));
                var delivery_price = Number(data[4].replace(/[^0-9\.]+/g, ""));
                var piece_per_size = Number(data[5].replace(/[^0-9\.]+/g, ""));
                var unit = $filter('filter')($scope.units, { 'unit': data[6] }, true);
                var delivery_offset = Number(data[7]) * 1;
                var unit_id = {};

                var equip = new Equipments({
                    name: name,
                    trade: $scope.my_trade_code,
                    trade_account: $scope.my_trade._id,
                    supplier: supplier,
                    category: category,
                    price_per_order: price_per_order,
                    delivery_price: delivery_price,
                    piece_per_size: piece_per_size,
                    unit: {
                        _id: (unit[0]) ? unit[0]._id : '',
                        unit: (unit[0]) ? unit[0].unit : ''
                    },
                    delivery_offset: delivery_offset
                });

                holder.push(equip);
            }

            Equipments.bulkAdd(holder, function (results) {
                results.forEach(function (eq) {
                    if ($scope.equipmentSuppliersList.indexOf(eq.supplier) === -1)
                        $scope.equipmentSuppliersList.push(eq.supplier)

                    $scope.equipment.push(eq);
                });
            });

            delete this.$parent.fileContent;
        };

        $scope.subtaskFileSelected = function () {
            var lines, lineNumber, data, length;

            lines = this.fileContent.split('\n');
            lines.shift(); //remove the heading
            lines.pop(); //remove the last entry that is an empty string

            if (lines.length !== $scope.my_trade.subtasks.length) {
                toaster.pop('error', 'Subtask Size Error',
                    'The number of subtask entries do not match.  Please export a new file and edit.');
                return;
            }
            var data = [];
            _.each(lines, function (line) {
                data = line.split(',');
                _.each(data, function (item) {
                    item = item.trim();
                });

                if (data.length !== 8) {
                    toaster.pop('error', 'Subtask Line Error',
                        'Make sure there are no commas in the spreadsheet');
                } else {
                    var item = $filter('filter')($scope.my_trade.subtasks, {
                        '_id': data[7]
                    }, true);

                    var found = true;
                    if (item.length !== 1) {
                        //didn't find it by id so lets try matching the name and task_code
                        item = $filter('filter')($scope.my_trade.subtasks, {
                            'code': data[0], 'name': data[1]
                        }, true);

                        if (item.length !== 1) {
                            toaster.pop('error', 'Subtask Line Error',
                                'Contact Admin');
                            found = false;
                        }
                    }

                    if (found) {
                        var error = false
                        if (isNaN(data[2]) || !angular.isNumber(+data[2])) {
                            toaster.pop('error', 'Crew Rate Error',
                                'Not a valid number');
                            error = true;
                        }

                        if (isNaN(data[3]) || !angular.isNumber(+data[3])) {
                            toaster.pop('error', 'Piece/Quantity Error',
                                'Not a valid number');
                            error = true;
                        }

                        if (isNaN(data[4]) || !angular.isNumber(+data[4])) {
                            toaster.pop('error', 'Piece/Hour Error',
                                'Not a valid number');
                            error = true;
                        }

                        if (data[3] > 0 && data[4] > 0) {
                            toaster.pop('error', 'Rate Data Error',
                                'Either Piece/Quantity or Piece/Hour has to be set to zero.');
                            error = true;
                        }

                        if (!error) {
                            var unit_check = $filter('filter')($scope.units, { 'unit': data[5] }, true);
                            if (unit_check.length !== 1) {
                                toaster.pop('warning', 'Unit Spelling Error',
                                    'Unit value (' + data[5] + ') is not a valid unit for subtask ' + data[1] +
                                    '. Setting unit value to NA');
                                data[5] = 'NA';
                            }

                            item[0].crew_rate = data[2];
                            item[0].piece_rate = data[3];
                            item[0].piece_per_hour_rate = data[4];
                            item[0].unit = data[5];
                            item[0].category = data[6];
                        }
                    }
                }
            });

            $scope.my_trade.$update(function (success) {
                $scope.my_trade = success;
                toaster.pop('success', 'Trade Subtasks Updated');
            }, function (error) {
                toaster.pop('error', 'Trade Subtask Error', error);
            });

            delete this.$parent.fileContent;
        };

        $scope.ConvertToCSV = function (objArray, isSupplier) {
            var str = isSupplier ? (csvExport.supplierMaterial.join(',') + '\r\n')
                : (csvExport.inventoryMaterial.join(',') + '\r\n');

            var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;

            for (var i = 0; i < array.length; i++) {
                str += array[i].name + ',' + array[i].category + ','
                    + array[i].supplier + ',' + array[i].price_per_order + ','
                    + array[i].delivery_price + ',' + array[i].piece_per_size + ','
                    + (array[i].unit ? array[i].unit.unit : 'NA') + ',' + array[i].delivery_offset;

                (!array[i].isInventory) ? (str += ',' + ',' + ',' + (array[i].isInventory ? 'Yes' : 'No') + '\r\n')
                    : (str += ',' + array[i].bulkQuantity + ',' + array[i].bulkPrice + ',' + (array[i].isInventory ? 'Yes' : 'No') + '\r\n');
            }
            return str;
        };

        $scope.ConvertToEquipmentCSV = function (objArray) {
            var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
            var str = 'Name,Category,Supplier,Price/Order,Delivery Price,Usage Rate,Unit of Usage,Days Offset\r\n';

            for (var i = 0; i < array.length; i++) {
                str += array[i].name + ',' + array[i].category + ','
                    + array[i].supplier + ',' + array[i].price_per_order + ','
                    + array[i].delivery_price + ',' + array[i].piece_per_size + ','
                    + array[i].unit.unit + ',' + array[i].delivery_offset + '\r\n';
            }

            return str;
        };

        $scope.ConvertToSubtaskCSV = function (objArray) {
            var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
            var str = 'Code,Subtask Name,Crew Rate,Piece/Quantity,Piece/Hour,Units,Category,ID - DO NOT EDIT\r\n';

            _.each(array, function (task) {
                _.each(task.subtasks, function (subtask) {
                    var cat = (subtask.category) ? subtask.category : '';
                    str += subtask.code + ',' + subtask.name + ',' + subtask.crew_rate + ','
                        + subtask.piece_rate + ',' + subtask.piece_per_hour_rate + ','
                        + subtask.unit + ',' + cat + ',' + subtask._id + '\r\n';
                });
            });

            return str;
        };

        $scope.exportFile = function () {
            var isSupplier = !$scope.isInventory;

            if (!Array.isArray($scope.materials) || !$scope.materials.length) {
                toaster.pop('error', 'Data Not Found',
                    'No Data to export. Please try with different filter option.');
                return;
            }

            var dataUrl = 'data:text/csv;utf-8,' + encodeURI($scope.ConvertToCSV($scope.materials, isSupplier));
            var link = document.createElement('a');
            var fileName = isSupplier ? 'supplier.csv' : 'inventory.csv';
            angular.element(link)
                .attr('href', dataUrl)
                .attr('download', fileName) // Pretty much only works in chrome
            link.click();
        };

        $scope.exportEquipmentFile = function () {
            var dataUrl = 'data:text/csv;utf-8,' + encodeURI($scope.ConvertToEquipmentCSV($scope.equipment));
            var link = document.createElement('a');
            angular.element(link)
                .attr('href', dataUrl)
                .attr('download', 'equipment.csv') // Pretty much only works in chrome
            link.click();
        };

        $scope.exportSubtaskFile = function () {
            var dataUrl = 'data:text/csv;utf-8,' + encodeURI($scope.ConvertToSubtaskCSV($scope.tasks));
            var link = document.createElement('a');
            angular.element(link)
                .attr('href', dataUrl)
                .attr('download', 'subtasks.csv') // Pretty much only works in chrome
            link.click();
        };

        $scope.deleteAll = function () {
            ngDialog.openConfirm({
                template:
                    '<h2>Delete Confirm</h2>' +
                    '<p>This operation will remove the material from the database.</p>' +
                    '<p><br><t><strong>Do you wish to continue?</strong></p>' +
                    '<div>' +
                    '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                    '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                    '</button></div>',
                plain: true,
                className: 'ngdialog-theme-default'
            }).then(function (value) {
                // perform delete operation
                if (value) {
                    $scope.materials.forEach(function (mat) {
                        mat.$delete();
                    });
                    $scope.materials = [];
                    $scope.suppliersList = [];
                }
            }, function (value) {
                //Do something
                console.log('in the do something section');
            });
        };

        $scope.deleteAllEquipment = function () {
            $scope.equipment.forEach(function (eq) {
                eq.$delete();
            });

            $scope.equipment = [];
            $scope.equipmentSuppliersList = [];
        };

        $scope.editDeliveryPrice = function (item) {
            item.deliveryPriceEditing = true;
        };

        $scope.doneDeliveryPriceEditing = function (item) {
            if (!item.deliveryPriceEditing) return;
            $scope.updateMaterial(item);
            item.deliveryPriceEditing = false;
        };

        $scope.editBulkPrice = function (item) {
            item.bulkPriceEditing = true;
        };

        $scope.doneBulkPriceEditing = function (item) {
            if (!item.bulkPriceEditing) return;
            $scope.updateMaterial(item);
            item.bulkPriceEditing = false;
        };

        $scope.editPricePerOrder = function (item) {
            item.pricePerOrderEditing = true;
        };

        $scope.donePricePerOrderEditing = function (item) {
            if (!item.pricePerOrderEditing) return;

            $scope.updateMaterial(item);

            item.pricePerOrderEditing = false;
        };

        $scope.editPrice = function (item) {
            item.priceEditing = true;
        };

        $scope.donePriceEditing = function (item) {
            if (!item.priceEditing) return;

            $scope.updateEquipment(item);

            item.priceEditing = false;
        };

        $scope.editUnits = function (item) {
            item.unitEditing = true;
        };

        $scope.doneUnitEditing = function (item) {
            if (!item.unitEditing) return;

            $scope.updateMaterial(item);

            item.unitEditing = false;
        };

        $scope.editGTaskNameEdit = function (item) {
            item.genTaskEditName = true;
        };

        $scope.doneGTaskNameEdit = function (item) {
            if (!item.genTaskEditName) return;

            item.$update(function(res) {
                $scope.getGnrlTskCombination($scope.selectedOpt);
            });

            item.genTaskEditName = false;
        };

        $scope.deleteGTask = function(gtask) {
            if(gtask.subtasks.length) {
                toaster.pop('error', 'Delete Error', 'You can\'t delete this general task with subtasks.');
                return;
            }
            var ordered_tasks = $filter('orderBy')($scope.customGeneraltask, 'order');
            if(ordered_tasks.length) {
                var lastTaskCode = ordered_tasks[ordered_tasks.length - 1].task_code;
                if(lastTaskCode === gtask.task_code) {
                    gtask.$remove(function(res) {
                        $scope.getGnrlTskCombination($scope.selectedOpt);
                    });
                } else {
                    toaster.pop('error', 'Delete Error', 'Delete latest general task first.');
                    return;
                }
            } else {
                gtask.$remove(function(res) {
                    $scope.getGnrlTskCombination($scope.selectedOpt);
                });
            }
            
        }

        $scope.editSubtaskCategory = function (item) {
            item.subtaskCategoryEditing = true;
        };

        $scope.doneSubtaskEditing = function (item) {
            if (!item.subtaskCategoryEditing) return;

            $scope.updateSubtask(item);

            item.subtaskCategoryEditing = false;
        };

        $scope.doneSubUnitEditing = function (item) {
            if (!item.unitEditing) return;

            if (!item.piece_per_hour_rate) item.piece_per_hour_rate = 0;
            if (!item.piece_rate) item.piece_rate = 0;

            if (!item.unit) {
                var found = $filter('filter')($scope.units, { 'unit': 'NA' }, true);
                item.unit = found[0];
            } else if (!item.unit.unit) {
                var found = $filter('filter')($scope.units, { 'unit': item.unit }, true);
                item.unit = found[0];
            }

            //first see if we have this item in our list
            var in_list = $filter('filter')($scope.my_trade.subtasks, { 'subtask_id': item.subtask_id }, true);

            if (in_list.length === 0) {
                // we need to add here
                $scope.my_trade.subtasks.push({
                    'subtask_id': item._id,
                    'name': item.subtask_name,
                    'code': item.subtask_code,
                    'task': item.subtask,
                    'trade': item.subtask_trade,
                    'unit': item.unit.unit,
                    'crew_rate': item.crew_rate,
                    'piece_rate': item.piece_rate,
                    'piece_per_hour_rate': item.piece_per_hour_rate
                });
            } else if (in_list.length === 1) {
                //we need to update here
                in_list[0].name = item.name;
                in_list[0].unit = item.unit.unit;
                in_list[0].crew_rate = Number(item.crew_rate);
                in_list[0].piece_rate = Number(item.piece_rate);
                in_list[0].piece_per_hour_rate = Number(item.piece_per_hour_rate);
            } else {
                toaster.pop('error', 'Trade Database', 'Problem with getting the subtask from the list');
                return;
            }

            $scope.my_trade.$update(function (results) {
                $scope.my_trade = results;
                if (item.unit.unit) item.unit = item.unit.unit;
                item.unitEditing = false;
                toaster.pop('success', 'Trade Database', 'Trade Database has been updated');
            }, function (error) {
                toaster.pop('error', 'Trade Database', error);
            });

            item.unitEditing = false;
        };

        $scope.editCrewRate = function (item) {
            item.crewRateEditing = true;
        };

        $scope.doneCrewRateEditing = function (item) {
            if (!item.crewRateEditing) return;

            $scope.update(item);

            item.crewRateEditing = false;
        };

        $scope.synchSubtasks = function () {
            Subtasks.query({
                type: 'syncTradeTask',
                subtask_trade: $scope.my_trade_code,
                main_account: $scope.main_account_id }, function (subtasks) {
                var updateData = []
                for (var i = 0; i < subtasks.length; i++) {

                    var savedData = $filter('filter')($scope.my_trade.subtasks, {
                        'task': subtasks[i].subtask,
                        'name': subtasks[i].subtask_name,
                        'projectType': subtasks[i].projectType,
                        'geoLocation': subtasks[i].geoLocation
                    }, true);

                    if (savedData.length === 0) {
                        updateData.push({
                            'subtask_id': subtasks[i]._id,
                            'name': subtasks[i].subtask_name,
                            'code': subtasks[i].subtask_code,
                            'task': subtasks[i].subtask,
                            'trade': subtasks[i].subtask_trade,
                            'unit': subtasks[i].unit ? subtasks[i].unit.unit : 'NA',
                            'checked': true,
                            'crew_rate': subtasks[i].crew_rate,
                            'piece_rate': subtasks[i].piece_rate,
                            'piece_per_hour_rate': subtasks[i].piece_per_hour_rate,
                            'geoLocation': subtasks[i].geoLocation,
                            'projectType': subtasks[i].projectType,
                            'isCustom': subtasks[i].isCustom || false,
                            'userId': subtasks[i].userId || ''
                        });
                    } else if (savedData.length === 1) {
                        updateData.push({
                            'subtask_id': subtasks[i]._id,
                            'name': subtasks[i].subtask_name,
                            'code': subtasks[i].subtask_code,
                            'task': subtasks[i].subtask,
                            'trade': subtasks[i].subtask_trade,
                            'unit': savedData[0].unit ? savedData[0].unit : 'NA',
                            'checked': true,
                            'crew_rate': savedData[0].crew_rate,
                            'piece_rate': savedData[0].piece_rate,
                            'piece_per_hour_rate': savedData[0].piece_per_hour_rate,
                            'geoLocation': savedData[0].geoLocation,
                            'projectType': savedData[0].projectType,
                            'category': savedData[0].category,
                            'isCustom': subtasks[i].isCustom || false,
                            'userId': subtasks[i].userId || ''
                        });
                    }
                    // else {
                    //     toaster.pop('error', 'Trade Database', 'Too many subtasks returned for updating.');
                    //     return;
                    // }

                }

                for (var i = 0; i < $scope.all_tasks.length; i++) {
                    var subs = $filter('filter')(updateData, {
                        'task': $scope.all_tasks[i].task,
                        'projectType': $scope.all_tasks[i].projectType,
                        'geoLocation': $scope.all_tasks[i].geoLocation
                    }, true);

                    $scope.all_tasks[i].subtasks = $filter('orderBy')(subs, 'name');
                }
                $scope.my_trade.subtasks = updateData;
                $scope.my_trade.$update(function (results) {
                    $scope.my_trade = results;
                    toaster.pop('success', 'Trade Database', 'Trade Database has been updated');
                }, function (error) {
                    toaster.pop('error', 'Trade Database', error);
                });
            });
        };

        $scope.syncOperation = function () {
            ngDialog.openConfirm({
                template:
                    '<h2>Sync With System Database</h2>' +
                    '<p>This operation will synchronize your subtasks with the system.</p>' +
                    '<p>This will update any changes to subtask names and add new subtasks if available</p>' +
                    '<p>This will not remove or change any number information you have but it is your responsibility to verify after synch.</p>' +
                    '<p><br><t><strong>Do you wish to continue?</strong></p>' +
                    '<div>' +
                    '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                    '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                    '</button></div>',
                plain: true,
                className: 'ngdialog-theme-default'
            }).then(function (value) {
                // perform delete operation
                $scope.synchSubtasks();
            }, function (value) {
                //Do something
                console.log('in the do something section');
            });
        };

        $scope.addMaterial = function (item) {

            var mat = new Materials({
                name: item.name,
                trade: $scope.my_trade_code,
                trade_account: $scope.my_trade._id,
                supplier: item.supplier,
                category: item.category,
                price_per_order: item.price_per_order,
                delivery_price: item.delivery_price,
                piece_per_size: item.piece_per_size,
                unit: {
                    _id: item.unit._id,
                    unit: item.unit.unit
                },
                delivery_offset: item.delivery_offset,
                isInventory: item.isInventory,
                bulkQuantity: item.bulkQuantity,
                bulkPrice: item.bulkPrice,
                userId: $scope.main_account_id
            });

            mat.$save(function (success) {
                $timeout(function () {
                    // add new category and suplier to the list
                    !$scope.categoryOptions.includes(success.category) && $scope.categoryOptions.push(success.category);
                    !$scope.supplierOptions.includes(success.supplier) && $scope.supplierOptions.push(success.supplier);
                    $scope.selectedCatergory = success.category;
                    $scope.selectedSupplier = success.supplier;
                    $scope.getTradeAccount(success.category, success.supplier);
                }, 0);
                toaster.pop('success', 'Material Added');
            }, function (error) {
                toaster.pop('error', 'Material Add Error', error)
            });
        };

        $scope.addMaterialOperation = function () {
            $scope.returnedMaterial = {
                name: '',
                category: '',
                supplier: '',
                price_per_order: 0,
                piece_per_size: 0,
                delivery_price: 0,
                unit: '',
                units_per_order: 0,
                delivery_offset: 0,
                isInventory: $scope.isInventory,
                bulkQuantity: 0,
                bulkPrice: 0
            };
            ngDialog.openConfirm({
                template: 'trades/views/tmpl/trade-add-material.html',
                scope: $scope,
                className: 'ngdialog-theme-default ngdialg-padding'
            }).then(function (value) {
                $scope.addMaterial($scope.returnedMaterial);
            }, function (value) {
                //Do something
                console.log('in the do something section');
            });

        };

        $scope.addEquipment = function (item) {
            var mat = new Equipments({
                name: item.name,
                trade: $scope.my_trade_code,
                trade_account: $scope.my_trade._id,
                supplier: item.supplier,
                category: item.category,
                price_per_order: item.price_per_order,
                delivery_price: item.delivery_price,
                piece_per_size: item.piece_per_size,
                unit: {
                    _id: item.unit._id,
                    unit: item.unit.unit
                },
                delivery_offset: item.delivery_offset
            });

            mat.$save(function (success) {
                $scope.equipment.push(success);
                toaster.pop('success', 'Material Added');
            }, function (error) {
                toaster.pop('error', 'Material Add Error', error)
            });
        };

        $scope.addEquipmentOperation = function () {
            $scope.returnedEquipment = {
                name: '',
                category: '',
                supplier: '',
                price_per_order: 0,
                piece_per_size: 0,
                delivery_price: 0,
                piece_per_size: 0,
                unit: '',
                units_per_order: 0,
                delivery_offset: 0
            };

            ngDialog.openConfirm({
                template: 'trades/views/tmpl/trade-add-equipment.html',
                scope: $scope,
                className: 'ngdialog-theme-default'
            }).then(function (value) {
                $scope.addEquipment($scope.returnedEquipment);
            }, function (value) {
                //Do something
                console.log('in the do something section');
            });

        };

        $scope.getTradeAccount = function (selectedCatergory, selectedSupplier, searchTerm) {
            selectedCatergory = (selectedCatergory && selectedCatergory !== 'All') && selectedCatergory || '';
            selectedSupplier = (selectedSupplier && selectedSupplier !== 'All') && selectedSupplier || '';
            $timeout(function () {
                Materials.query({
                    'trade_account': $scope.my_trade['_id'],
                    //'isInventory': $scope.isInventory,
                    'userId': $scope.main_account_id,
                    filters: JSON.stringify({ category: selectedCatergory, 
                        supplier: selectedSupplier,
                        searchTerm: searchTerm 
                    }),
                }, function (mat) {
                    $scope.materials = mat;
                    //$scope.overridden_materials = mat;
                    $scope.onMaterialTypeSelect();
                });
            }, 0);
        };

        /**
         * @description getting the selected project type- geolocation
         */
        $scope.getGnrlTskCombination = (selectedCombination) => {
            var query = {
                projectType: selectedCombination.projectType || selectedCombination.type,
                geoLocation: selectedCombination.geoLocation || selectedCombination.location,
                trade: $scope.my_trade_code,
                isCustom: selectedCombination['isCustom'],
                userId: selectedCombination['userId']
            };
            selectedCombination['isCustom'] ? $scope.getCustomTask(query) : $scope.getGnrlTask(query);
        }

        /**
         * @description fetch custom general task and subtask
        */
        $scope.getCustomTask = (query) => {
            $scope.isCustomSelected = true;
            query['isCustom'] = true;
            query['userId'] = $scope.main_account_id;
            $scope.updateCustomTasks(query);
        }

        $scope.supplierModalActivated = function(task_id, index, subtask_idx) {
            $scope.override_task_id = task_id;
            $scope.override_index = index;
            $scope.override_subtask_idx = subtask_idx;

            if(!$scope.available_suppliers) {
                $scope.available_suppliers = [];

                Materials.query({
                    'trade_account': $scope.my_trade._id,
                    'userId': $scope.main_account_id
                 }, function(materials) {
                    $scope.all_materials = materials;

                    $scope.onMaterialTypeSelect($scope.defaultMaterialType);
                });
            }
        };
console.log('TradeTasksController');
        $scope.onMaterialTypeSelect = (isInventory)=>{
            var query = {
                'trade_account': $scope.my_trade._id,
                'type':'MaterialFilter',
                //'isInventory':isInventory,
                'supplier':true,
                'userId': $scope.main_account_id
            }

            if(isInventory == 'From Inventory') {
                query.isInventory = true;
            } else if(isInventory == 'From Supplier') {
                query.isInventory = false;
            }

            Materials.query(query, (supplier) => {
                $scope.available_suppliers = [];
                supplier.forEach(e=>{
                    $scope.available_suppliers.push({name: e});
                });
                $scope.available_suppliers.unshift({name: 'All'});

                $scope.override_supplier = $scope.available_suppliers[0];
                $scope.onSupplierSelect($scope.available_suppliers[0], isInventory);
            });
        };

        $scope.onSupplierSelect = function(new_supplier, isInventory = 'All') {
            if(new_supplier ==  null) {
                new_supplier: {
                    name: 'All'
                };
            }
            //var queryFilter = { 'isInventory':  false  };
            if(isInventory != 'All') {
                var invParams = (isInventory == 'From Inventory' ? true : false);
                var queryFilter = { 'isInventory':  invParams  };

                if(new_supplier.name != 'All')
                    (new_supplier) && (queryFilter['supplier'] = new_supplier.name);

                $scope.overridden_materials = $filter('filter')($scope.materials, queryFilter , true);
            } else {
                var queryFilter = {};
                if(new_supplier.name != 'All')
                    (new_supplier) && (queryFilter['supplier'] = new_supplier.name);

                $scope.overridden_materials = $filter('filter')($scope.materials, queryFilter , true);
            }

            $scope.overridden_categories = [];
            $scope.overridden_materials = $filter('orderBy')($scope.overridden_materials, 'name');

            $scope.overridden_materials.forEach(function(material, idx) {
                var in_list = $filter('filter')($scope.overridden_categories, {name: material.category}, true);
                if(in_list.length === 0) {
                    $scope.overridden_categories.push({
                        name: material.category
                    });
                }
            });
            $scope.overridden_categories.unshift({name: 'All'});
            $scope.override_category = $scope.overridden_categories[0];
        };

        $scope.supplierModalActivated = function(item) {

        };

        $scope.addMultipleMaterials = function(
            override_task_id, override_subtask_idx, new_materials, new_note) {
            if(new_materials.length === 0) {
                alert('No Material Selected!');
                return;
            }

            var subtask = $filter('filter')($scope.my_trade.subtasks, {
                '_id': $scope.editId}, true)[0];

            if(!subtask) {
                toaster.pop('error', 'Problem Finding Subtask');
                return;
            }

            _.each(new_materials, function(material, index) {
                material.note = new_note;
                //$scope.addMaterialForMultiple(override_task_id, override_subtask_idx, material, times[index]);
            });

            _.each(new_materials, function(mat, idx) {
                mat.unit = mat.unit.unit;
                subtask.materials.push(mat);
            });

            $scope.closeEdit(subtask);

            //var saved_tasks = angular.copy($scope.my_bid.task_list);

            // $scope.show_spinner = true;
            // $scope.my_bid.$update(function(success) {
            //     toaster.pop('success', 'Material Added', 'Database Updated');
            //     $scope.updateShowState(saved_tasks, success.task_list);
            //     $scope.my_bid = success;
            //     $scope.show_spinner = false;
            // }, function(error) {
            //     toaster.pop('error', 'Material Add Multiple Error', error);
            // });

            this.current_material = this.current_category = '';
            if(this.current_material)
              this.current_material.note = '';

            this.new_supplier = this.new_category = '';
            this.new_materials = [];
        };

        $scope.deleteMaterialFromSubtask = function(material, index) {
            var subtask = $filter('filter')($scope.my_trade.subtasks, {
                '_id': $scope.editId}, true)[0];

            if(!subtask) {
                toaster.pop('error', 'Problem Finding Subtask');
                return;
            }

            subtask.materials.splice(index, 1);
            $scope.closeEdit(subtask);
        }
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/trades/public/controllers/tradeTasks.js